import * as React from 'react';

const Checklist = () => (
  <svg width={82} height={91} viewBox="0 0 82 91" stroke="none" strokeWidth={1} fillRule="evenodd">
    <rect fill="#FFFFFF" x={0} y={0} width={72} height={82} rx={8} />
    <rect
      stroke="#1F223B"
      strokeWidth={3}
      fill="none"
      x={1.5}
      y={1.5}
      width={69}
      height={79}
      rx={8}
    />
    <rect fill="#F8F8F9" x={10} y={10} width={52} height={10} rx={2} />
    <rect fill="#9EA1AE" x={14} y={32} width={26} height={2} rx={1} />
    <path
      fill="#505FB4"
      d="M51.439,36.561 C52.025,37.147 52.975,37.147 53.56,36.561 L59.561,30.561 C60.146,29.975 60.146,29.025 59.561,28.439 C58.975,27.854 58.025,27.854 57.439,28.439 L52.517,33.396 L50.561,31.44 C49.975,30.854 49.025,30.854 48.439,31.439 C47.854,32.025 47.854,32.975 48.439,33.561 L51.439,36.561 Z"
    />
    <rect fill="#9EA1AE" x={14} y={48} width={26} height={2} rx={1} />
    <path
      fill="#505FB4"
      d="M51.439,52.561 C52.025,53.147 52.975,53.147 53.56,52.561 L59.561,46.561 C60.146,45.975 60.146,45.025 59.561,44.439 C58.975,43.854 58.025,43.854 57.439,44.439 L52.517,49.396 L50.561,47.44 C49.975,46.854 49.025,46.854 48.439,47.439 C47.854,48.025 47.854,48.975 48.439,49.561 L51.439,52.561 Z"
    />
    <rect fill="#9EA1AE" x={14} y={64} width={26} height={2} rx={1} />
    <path
      fill="#505FB4"
      d="M51.439,68.561 C52.025,69.147 52.975,69.147 53.56,68.561 L59.561,62.561 C60.146,61.975 60.146,61.025 59.561,60.439 C58.975,59.854 58.025,59.854 57.439,60.439 L52.517,65.396 L50.561,63.44 C49.975,62.854 49.025,62.854 48.439,63.439 C47.854,64.025 47.854,64.975 48.439,65.561 L51.439,68.561 Z"
    />
    <path
      fill="#1C1F34"
      d="M58.454,55.186 C58.455,54.336 58.616,53.591 58.892,52.938 C48.106,53.233 39.419,61.949 39.419,72.647 C39.419,75.184 39.925,77.604 40.815,79.835 C41.136,79.639 41.481,79.461 41.863,79.314 C45.779,77.801 49.44,75.852 52.997,73.73 C55.93,67.892 58.444,61.798 58.454,55.186"
      opacity={0.200000003}
    />
    <path
      fill="#505FB4"
      d="M79.922,71.913 C79.922,62.248 72.086,54.412 62.42,54.412 C52.754,54.412 44.918,62.248 44.918,71.913 C44.918,81.579 52.754,89.416 62.42,89.416 C72.086,89.416 79.922,81.579 79.922,71.913"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      fill="none"
      d="M79.922,71.913 C79.922,62.248 72.086,54.412 62.42,54.412 C52.754,54.412 44.918,62.248 44.918,71.913 C44.918,81.579 52.754,89.416 62.42,89.416 C72.086,89.416 79.922,81.579 79.922,71.913 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      stroke="#FFFFFF"
      strokeWidth={3}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="53.904 74.822 58.061 78.979 70.774 66.266"
    />
  </svg>
);

export default Checklist;



// WEBPACK FOOTER //
// ./src/assets/images/icons/checklist.js